import React from "react";

/**
 * Premium skeleton — matte card blocks with a shimmering gold sheen.
 * Used for lazy-loaded route fallbacks so users never see a bare screen.
 */
function Bar({ className = "" }) {
  return (
    <div
      className={
        "relative overflow-hidden bg-white/[0.04] " + className
      }
      aria-hidden="true"
    >
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.6s_infinite] bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" />
    </div>
  );
}

export default function PageSkeleton() {
  return (
    <div
      data-testid="page-skeleton"
      className="space-y-10"
      role="status"
      aria-live="polite"
      aria-label="Loading page"
    >
      {/* Header block */}
      <div className="space-y-3">
        <Bar className="h-3 w-40" />
        <Bar className="h-9 w-72" />
        <Bar className="h-4 w-96" />
      </div>

      {/* Stat cards */}
      <div className="grid gap-4 md:grid-cols-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="border border-white/10 bg-matte-card p-6 space-y-4">
            <Bar className="h-3 w-24" />
            <Bar className="h-10 w-20" />
            <Bar className="h-3 w-32" />
          </div>
        ))}
      </div>

      {/* Large card */}
      <div className="border border-white/10 bg-matte-card p-8 space-y-4">
        <Bar className="h-4 w-32" />
        <Bar className="h-3 w-full" />
        <Bar className="h-3 w-5/6" />
        <Bar className="h-3 w-3/4" />
      </div>
    </div>
  );
}
